import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

function Contacts({contacts, service, displayAmount = 30, setSelectedContact, displaySendAgain }) {

    const [filteredContacts, setFilteredContacts] = useState(null);

    const decodeHtml = (str) => {
    if (!str) return "";

    return str
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#039;/g, "'")
        .replace(/&nbsp;/g, " ")
        .replace(/&aacute;/g, "á")
        .replace(/&eacute;/g, "é")
        .replace(/&iacute;/g, "í")
        .replace(/&oacute;/g, "ó")
        .replace(/&uacute;/g, "ú")
        .replace(/&Aacute;/g, "Á")
        .replace(/&Eacute;/g, "É")
        .replace(/&Iacute;/g, "Í")
        .replace(/&Oacute;/g, "Ó")
        .replace(/&Uacute;/g, "Ú")
        .replace(/&ntilde;/g, "ñ")
        .replace(/&Ntilde;/g, "Ñ")
        .replace(/&uuml;/g, "ü")
        .replace(/&Uuml;/g, "Ü")
        .replace(/&ouml;/g, "ö")
        .replace(/&Ouml;/g, "Ö")
        .replace(/&szlig;/g, "ß")
        .replace(/&euro;/g, "€")
        .replace(/&copy;/g, "©")
        .replace(/&reg;/g, "®");
};

    useEffect(() => {
        if (!contacts) return;

        const filtered = contacts.filter((contact) => {
            try {
                const otherdata = JSON.parse(
                    contact?.Usercontactlistexternal?.other?.replaceAll(/&(amp;)*quot;/g, '"')
                );
                return otherdata?.type === service;
            } catch (error) {
                console.error("Error parsing 'other' JSON:", error);
                return false;
            }
        });

        setFilteredContacts(filtered);
    }, [contacts, service]);



    return (
        <Box
            sx={{
                maxHeight: '225px',
                overflowY: 'auto',
                paddingRight: 1,
            }}
        >
            <Box className="d-flex justify-content-start flex-wrap gap-3 mt-4">
                {filteredContacts?.slice(0, displayAmount).map((row, index) => {
                    const data = row.Usercontactlistexternal;
                    let otherdata = {};
                    try {
                        otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
                    } catch (error) {

                    }

                    
                    let name = ["EMER", "RIA", "BPI"].includes(otherdata?.type)
                        ? `${data.firstName} ${data.lastName}`
                        : data.lastName;

                        

                        if (service === "MoneyGram") {
                         name = decodeHtml(name);
    }
                        
                    // const name = otherdata?.type === "EMER" ? `${data.firstName} ${data.lastName}` : data.lastName
                    return (
                        <Box className="border rounded p-3 light-grey-border" key={data.id}>
                            <Box className="text-black fs-size-14 fw-bold">{name}</Box>
                            <Box className="text-muted fs-size-10">{otherdata?.ctry ?? otherdata?.receivercountrycode ?? ''}</Box>
                            {displaySendAgain !== false && <button
                                className="border w-100 border-dark bg-white mt-2 border-50-round border-2 fs-size-12 fw-bold"
                                onClick={() => setSelectedContact(row)}
                            >
                                Send Again
                            </button>}
                        </Box>);
                })}
            </Box>
        </Box>
    );
}

export default Contacts;